import { OrderProduct, orderProductFromResponse } from './OrderProduct';
import { OrderTotal, orderTotalFromResponse } from './OrderTotal';

export interface Order {
  id: number;
  createdAt: Date;
  paymentMethod: string;
  status: string;
  notes: string;
  cargoURL?: string;
  products: OrderProduct[];
  canRefund: boolean;
  discount: OrderTotal;
  shippingMethod: string;
  shippingCost: OrderTotal;
  installment?: string;
  pointUsage: number;
  total: OrderTotal;
  billingFirstName: string;
  billingLastName: string;
  billingAddress: string;
  shippingFirstName: string;
  shippingLastName: string;
  shippingAddress: string;
  customerPhone: string;
  customerEmail: string;
}

export const orderFromResponse = (responseData: any): Order => ({
  id: responseData.id,
  createdAt: new Date(responseData.created_at),
  paymentMethod: responseData.payment_method,
  status: responseData.status,
  notes: responseData.notes,
  cargoURL: responseData.cargo_url,
  products: responseData.products.map(orderProductFromResponse),
  canRefund: responseData.can_refund,
  discount: orderTotalFromResponse(responseData.discount),
  shippingMethod: responseData.shipping_method,
  shippingCost: orderTotalFromResponse(responseData.shipping_cost),
  installment: responseData.installment,
  pointUsage: responseData.point_usage,
  total: orderTotalFromResponse(responseData.total),
  billingFirstName: responseData.billing_first_name,
  billingLastName: responseData.billing_last_name,
  billingAddress: responseData.billing_address_1,
  shippingFirstName: responseData.shipping_first_name,
  shippingLastName: responseData.shipping_last_name,
  shippingAddress: responseData.shipping_address_1,
  customerPhone: responseData.customer_phone,
  customerEmail: responseData.customer_email,
});
